import { useMemo } from 'react';
import { statusColor } from '../components/relevancy-summary-popup/config';
import { CompanyRelevancy } from '../types';
import { getRelevancyConfig } from '../utils';

export const useRelevancyConfig = (relevancy?: CompanyRelevancy | null) => {
  return useMemo(() => {
    if (!relevancy?.score) {
      return null;
    }

    const relevancyConfig = getRelevancyConfig(relevancy.score);
    const colorKey = relevancyConfig?.grade as keyof typeof statusColor;
    const color = statusColor[colorKey];

    return {
      config: relevancyConfig,
      color,
      score: relevancy.score,
    };
  }, [relevancy?.score]);
};
